import React, { useState } from "react";
import { api, formatDetail } from "../lib/api";
import { useAuth } from "../lib/store";
import { toast } from "sonner";
import { inferRidePaceClass, PACE_CHIP_LABEL, PACE_CHIP_CLS } from "../lib/ride";

const CYCLE = ["social", "tempo", "race"];

// Pace chip. Plain badge for riders; El Presidente taps it to force
// Social → Tempo → Race → back to Auto (description-derived).
export default function PaceChip({ ride, onChange, testId }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const paceCls = inferRidePaceClass(ride);
  const forced = !!ride.pace_override;
  const cls = `inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full border ${PACE_CHIP_CLS[paceCls]}`;

  if (!user?.is_president) {
    return (
      <span className={cls} data-testid={testId}>
        {PACE_CHIP_LABEL[paceCls]}
      </span>
    );
  }

  async function cycle(e) {
    e.stopPropagation();
    e.preventDefault();
    if (busy) return;
    const idx = forced ? CYCLE.indexOf(ride.pace_override) : -1;
    const next = idx === CYCLE.length - 1 ? null : CYCLE[idx + 1];
    setBusy(true);
    try {
      const { data } = await api.patch(`/rides/${ride.id}/pace`, { pace: next });
      onChange?.(data);
      toast(next ? `Pace forced to ${PACE_CHIP_LABEL[next]}` : "Pace back to auto");
    } catch (err) { toast.error(formatDetail(err)); }
    finally { setBusy(false); }
  }

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={cycle}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") cycle(e); }}
      className={`${cls} cursor-pointer select-none active:scale-95 transition-transform ${busy ? "opacity-50" : ""} ${forced ? "ring-1 ring-current" : "border-dashed"}`}
      title={forced ? "Tap to change · forced by El Prez" : "Tap to force pace"}
      data-testid={testId}
      data-forced={forced ? "true" : "false"}
    >
      {PACE_CHIP_LABEL[paceCls]}
      <span className="opacity-60 normal-case tracking-normal font-mono-stat text-[9px]">{forced ? "· forced" : "· auto"}</span>
    </span>
  );
}
